/* eslint-env node */

import moment from 'moment'
import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider, addLocaleData } from 'react-intl'
import { connect } from 'react-redux'

import { FormatsManager } from 'react-wot-bootstrap'
import { FormatsManager as MonorepoFormatsManager } from '@wotfe/formatters'
import { getCurrentLanguage, localeDataHash } from 'locale'

import { requestLocale } from 'state/actions/locale'

import UpdateIntl from './components/UpdateIntl'

export class LocaleWrapper extends React.Component {
    static propTypes = {
        loaded: PropTypes.bool,
        messages: PropTypes.object.isRequired,
        realm: PropTypes.string.isRequired,

        requestLocale: PropTypes.func.isRequired,
    }

    constructor(props){
        super(props)
        this.language = getCurrentLanguage().toLowerCase().replace('_', '-')
        moment.locale(this.language)
    }

    componentWillMount() {
        addLocaleData(localeDataHash[this.language])
        this.props.requestLocale(this.language)

        MonorepoFormatsManager.initializeFormats(this.props.realm, this.language)

        // hack until react-wot-bootstrap gets ASIA realm formats https://jira.wargaming.net/browse/WGSH-3442
        let realm = this.props.realm
        if (realm === 'asia') realm = 'sg'
        if (realm === 'cn360') realm = 'cn0'

        FormatsManager.initializeFormats(realm, this.language)
    }

    render() {
        if (!this.props.loaded) return null

        return (
            <IntlProvider locale={this.language} defaultLocale={this.language} messages={this.props.messages}>
                <div>
                    <UpdateIntl/>
                    {this.props.children}
                </div>
            </IntlProvider>
        )
    }
}

export const mapStateToProps = ({ locale, settings }) => {
    const { loaded, messages } = locale
    const { realm } = settings
    return { loaded, messages, realm }
}

export const mapDispatchToProps = {
    requestLocale,
}

export default connect(mapStateToProps, mapDispatchToProps)(LocaleWrapper)



// WEBPACK FOOTER //
// ./containers/LocaleWrapper/LocaleWrapper.jsx